import React from "react"
import { Link, StaticQuery, graphql } from "gatsby"

import "../scss/components/recentPosts.scss"


function RecentPosts() {
	return (
		<StaticQuery
			query={recentPostsQuery}
			render={data => {
				const posts = data.allContentfulBlogPost.edges
				return (
					<div className="recentPostWrap">
						<h3>Recent Posts</h3>
        		{posts.map(({ node }) => {
        		  const title = node.title || node.slug
        		  return (
        		    <div className="recentPost" key={node.slug}>
									<Link to={`/${node.slug}`}>
        		      	<div className="recentPostText">
        		      	  <h3>
        		      	    {title}
        		      	  </h3>
											<span className="recentPostMeta">
												<time>{node.createdAt}</time>
												<span className={node.category}>{node.category}</span>
											</span>
											<p
        		    	    dangerouslySetInnerHTML={{
        		    	      __html: node.description || node.excerpt,
        		    	    }}
        		    	  	/>
        		      	</div>
									</Link>
        		    </div>
        		  )
        		})}
        	</div>
				)
			}}
		/>
	)
}


const recentPostsQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulBlogPost(
			limit: 4
			sort: { fields: [createdAt], order: DESC }
		) {
      edges {
        node {
          title
          description
					slug
					category
					createdAt(formatString: "YYYY.MM.DD")
          thumbnail {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  }
`
export default RecentPosts
